import { css } from '@emotion/react';

import { makeStyles } from '@toolbox/style';
import { InputError } from './InputError';
import { Flex } from '../Flex';
import { Tooltip } from '../Tooltip';
import { icons } from '../Icon/icons/index';

import type { FC, InputHTMLAttributes, ReactChild } from 'react';
import type { IconName } from '../Icon/icons';
import type { Placement } from '@popperjs/core';

export type InputWrapperProps = InputHTMLAttributes<HTMLInputElement> & {
  error?: ReactChild | boolean | null;
  keepErrorSpace?: boolean;
  showTooltip?: boolean;
  tooltip?: string;
  tooltipPlacement?: Placement;
  tooltipIcon?: IconName;
  name?: string;
};

const useStyles = makeStyles(({ theme }) => ({
  root: css`
    text-align: left;
  `,
  error: css`
    border-color: ${theme.palette.colors.error};
  `,
}));

export const InputWrapper: FC<InputWrapperProps> = (props) => {
  const {
    keepErrorSpace,
    error,
    showTooltip,
    tooltip,
    tooltipPlacement = 'bottom-end',
    tooltipIcon,
    children,
    name,
  } = props;
  const classes = useStyles();

  const Icon = icons[tooltipIcon || 'QuestionMarkIcon'];

  const placement =
    window.innerHeight < 600 && window.innerWidth > 767 ? 'top-start' : tooltipPlacement;

  return (
    <div css={classes.root as any}>
      <Flex
        style={{
          width: '100%',
          columnGap: '8px',
          justifyContent: 'center',
          alignItems: 'center',
        }}
      >
        {children}
        {showTooltip && (
          <Tooltip id={name || ''} placement={placement} text={tooltip}>
            {<Icon type={tooltipIcon || 'QuestionMarkIcon'} css={{ cursor: 'pointer' } as any} />}
          </Tooltip>
        )}
      </Flex>
      {((error && error !== true) || keepErrorSpace) && (
        <InputError>{error !== true && error}</InputError>
      )}
    </div>
  );
};
